import { Observable, of  } from 'rxjs';
import { ConnectionService } from '../services/connection/connection.service';
import { AuthenticationService } from '../../user/services/authentication.service';

export abstract class AuthBase {
    protected constructor(protected authenticationService: AuthenticationService, protected connectionService: ConnectionService) {
    }

    protected checkAuthorization(): Observable<boolean> {
        // removed auth check for now to avoid conflicting with the token refresh process.
        return of(true);
    }

    protected checkAuthorizationOriginal(): Observable<boolean> {
        return new Observable(subscriber => {
            subscriber.next(this.authenticationService.isAuthenticated);
            subscriber.complete();
        });
    }
}
